module.exports = "static/assets/1ae8d814e5c6189c51ac45b5082ece37.svg";